
	export default {
		props: {
			rules: Object,
			answers: {
				type: Object,
				default: () => ({})
			},
			score: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				lines: [],
				lineColors: [],
				checkboxes: [
					{
						title: "ACEi/ARB", 
						fullTitle: 'ACEi/ARB',
						type: 'radio',
						name: 'radio-1'
					},
					{
						title: "ARNI", 
						fullTitle: 'Angiotension Receptor Neprilysin Inhibitor',
						type: 'radio',
						name: 'radio-1'
					},
					{
						title: "Anticoagulant", 
						fullTitle: 'Anticoagulant',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "SGLTi", 
						fullTitle: 'Sodium Glucose Co-Transporter Inhbitor',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "GLP1-RA", 
						fullTitle: 'GLP-1 Receptor Antagonist.',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "Statin", 
						fullTitle: 'Statin',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "Additional LLT", 
						fullTitle: 'Additional LLT',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "Evi. Based BB >50% max Dose", 
						fullTitle: 'Evi. Based BB >50% max Dose',
						type: 'radio',
						name: 'radio-2'
					},
					{
						title: "Evi. Based BB <50% max Dose", 
						fullTitle: 'Evi. Based BB <50% max Dose',
						type: 'radio',
						name: 'radio-2'
					},
					{
						title: "nsMRA", 
						fullTitle: 'Non-steroidal Mineralocorticoid Receptor Antagonist',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "sMRA", 
						fullTitle: 'Steroidal Mineralocorticoid Receptor Antagonist',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "BetaBlocker", 
						fullTitle: 'Beta Blocker',
						type: 'checkbox',
						name: 'checkbox'
					}
				]
			}
		},
		watch: {
			answers: {
				handler(newVal, oldVal) {
					this.$nextTick(() => {
						requestAnimationFrame(() => {
							this.drawLines();
						});
					});
				},
				deep: true,
				immediate: false
			}
		},
		mounted() {
			this.$nextTick(() => {
				requestAnimationFrame(() => {
					this.drawLines();
				});
			});
		},
		methods: {
			drawLines() {
				const container = document.querySelector('.learn-more').getBoundingClientRect();
				const circle = document.querySelector('.circle').getBoundingClientRect();
			    const listLi  = document.querySelectorAll('.cols li');
			    const paths = [];
			    const colors = [];

		        listLi.forEach(liEl => {
		        	const isSel = liEl.classList.contains('selected');
		        	const rect = liEl.getBoundingClientRect();
		        	
		        	const x1 = rect.right - container.left;
			        const y1 = rect.top + rect.height/2 - container.top;
			        const x2 = circle.left - container.left;
			        const y2 = circle.top + circle.height/2 - container.top;
			        const ctrlX = x1 + (x2 - x1) * 0.5;

			        paths.push(`M${x1},${y1} C${ctrlX},${y1} ${ctrlX},${y2} ${x2},${y2}`);
			        colors.push(isSel ? '#195a8d' : '#cccccc');
		        });

			    this.lines = paths;
			    this.lineColors = colors;
			},
			isRuleEnabled(ruleName) {
			 	return this.rules[ruleName] === true;
			}
		},
		computed: {
			totalMin() {
				let count = 0;

				if (this.answers.questionFirst.includes('AFF')) {
					count += Number(this.score.score_aff.min) || 0;
				} 

				if (this.answers.questionFirst.includes('Chronic Kidney Disease')) {
					count += Number(this.score.score_ckd.min) || 0;
				}

				if (this.answers.questionFirst.includes('ASCVD')) {
					count += Number(this.score.score_ascvd.min) || 0;
				} 

				if (this.answers.questionFirst.includes('HFrEF/HFmrEF') || this.answers.questionFirst.includes('HFpEF')) {
					count += Number(this.score.score_hf.min) || 0;
				}

				return count;
			},
			totalMax() {
			    let count = 0;

				if (this.answers.questionFirst.includes('AFF')) {
					count += Number(this.score.score_aff.max) || 0;
				} 

				if (this.answers.questionFirst.includes('Chronic Kidney Disease')) {
					count += Number(this.score.score_ckd.max) || 0;
				}

				if (this.answers.questionFirst.includes('ASCVD')) {
					count += Number(this.score.score_ascvd.max) || 0;
				} 

				if (this.answers.questionFirst.includes('HFrEF/HFmrEF') || this.answers.questionFirst.includes('HFpEF')) {
					count += Number(this.score.score_hf.max) || 0;
				}

				return count;
			},
			percent() {
				return this.totalMax ? (this.totalMin / this.totalMax) * 100 : 0;
			}
		}
	}
